import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { MaskModelType } from 'src/domains/sportsbook/state/alternativeEventState/AlternativeCustomSelectionState';
import {
    ParticipantColor,
    ParticipantColorWrapper,
    SilkCellRaceBox,
} from 'src/domains/sportsbook/webview/modules/AlternativeEvent/alternativeMainContent/AlternativeMainContent.style';
import { SelectionId } from 'src_common/common/websocket2/id/WebsocketId';

interface MaskImgPropsType {
    mask: MaskModelType | null;
    selectionId: SelectionId | null;
}

export const MaskImg = observer('MaskImg', ({ mask, selectionId }: MaskImgPropsType) => {
    const selectionModel = selectionId?.getModel() ?? null;
    if (selectionModel === null) {
        return null;
    }

    if (mask === null) {
        return null;
    }

    const silkAltDesc = selectionModel.metaDataSilk ?? '';

    return (
        <ParticipantColorWrapper>
            {mask.color.length > 0 ? <ParticipantColor teamColor={mask.color} /> : null}

            {mask.url.length > 0 ? (
                <SilkCellRaceBox
                    alt={silkAltDesc}
                    imgBase={{
                        src: mask.url,
                        optimizeOptions: {
                            quality: 85,
                            width: 54,
                        },
                    }}
                />
            ) : null}
        </ParticipantColorWrapper>
    );
});
